import React, { ReactNode } from 'react';
import styles from './assets/expense-screen.module.scss';
import classNames from 'classnames';
import ExpensesGrid from './components/ExpensesGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateExpenseButton from './components/CreateExpenseButton';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IExpense } from 'src/types/expense';
import Loader from '../../../../../../components/Loader';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';

export interface StateProps {
    data: Paginated<IExpense>;
    inProgress: boolean;
    providers: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class ExpensesList extends React.Component<Props> {
    componentDidMount() {
        this.props.getProviders({});
    }
    public render(): ReactNode {
        const { data, getData, providers, inProgress } = this.props;

        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();
        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={`${classNames('pageHeading')}`}>
                    <h2 className={`${classNames('pageHeadingTitle')}`}>
                        EXPENSES {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>

                    <CreateExpenseButton />
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <ExpensesGrid
                        providers={providers}
                        data={data}
                        getDataCsv={this.props.getDataCsv}
                        getData={getData}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default ExpensesList;
